<template>
  <div style="height:100%">
    <el-table
        :data="pinnacleInfo"
        height="100%"
        class="InverterTable"
        style="width: 100%;height:100%;"
        v-if="routeName=='Inverter'">
        <el-table-column
          prop="name"
          label="名称"
          width="120px"
         >
        </el-table-column>
        <el-table-column
          prop="total"
          label="总发电量"
          width="120px"
         >
        </el-table-column>
        <template v-if="radio=='day'">
          <el-table-column
              v-for="(item, index) in 24"
              :key="index"
              :prop="(index<10?'0'+index:index)+':00'"
              :label="(index<10?'0'+index:index)+':00'"
            >
            </el-table-column>
        </template>
        <template v-if="radio=='month'">
          <el-table-column
              v-for="(item, index) in 31"
              :key="index"
              :prop="item+'日'"
              :label="item+'日'"
            >
            </el-table-column>
        </template>
        <template v-if="radio=='year'">
          <el-table-column
              v-for="(item, index) in 12"
              :key="index"
              :prop="item+'月'"
              :label="item+'月'"
            >
            </el-table-column>
        </template>
      </el-table>
    <el-table
        :data="pinnacleInfo"
        class="pinnacleTable"
        style="width: 100%;height:100%;"
        v-else>
        <el-table-column
          prop="name"
          label="名称"
         >
        </el-table-column>

        <template v-if="radio=='day'">
            <el-table-column
            prop="day_rush"
            label="日充电量"
          >
          </el-table-column>
          <el-table-column
            prop="day_put"
            label="日放电量"
          >
          </el-table-column>
          <el-table-column
            v-for="(item, index) in 24"
            :key="index"
            :prop="(index<10?'0'+index:index)+':00'"
            :label="(index<10?'0'+index:index)+':00'"
          >
            <el-table-column
              :prop="index+'_rush'"
              label="充电量"
              >
            </el-table-column>
            <el-table-column 
              :prop="index+'_put'" 
              label="放电量" 
              >
              
            </el-table-column>
          </el-table-column>
        </template>

        <template  v-else-if="radio=='month'">
           <el-table-column
            prop="total"
            label="月充电量"
          >
          </el-table-column>
          <el-table-column
            prop="total"
            label="月放电量"
          >
          </el-table-column>
         
          <el-table-column
            v-for="item in 31"
            :key="item"
            :prop="item"
            :label="item+'日'"
          >
            <el-table-column
              prop="sum_valley"
              label="充电量"
              >
            </el-table-column>
            <el-table-column 
              prop="percentage_valley" 
              label="放电量" 
              >
              
            </el-table-column>
          </el-table-column>
        </template>
        
        <template v-else-if="radio=='year'">
           <el-table-column
            prop="total"
            label="年充电量"
          >
          </el-table-column>
          <el-table-column
            prop="total"
            label="年放电量"
          >
          </el-table-column>
            <el-table-column
            v-for="item in 12"
            :key="item"
            :prop="item"
            :label="item+'月'"
          >
          <el-table-column
              prop="sum_valley"
              label="充电量"
              >
            </el-table-column>
            <el-table-column 
              prop="percentage_valley" 
              label="放电量" 
              >
            </el-table-column>
          </el-table-column>
        </template>
       
      </el-table>
  </div>
</template>


<script>
  export default {
    props:{
      routeName:String,
      radio:String,
      pinnacleInfo:Array

    },
    data() {
      return {
        
      }
    },
    created(){
      
    }
  }
</script>

<style  scoped lang="less">
  .InverterTable /deep/.el-table__body-wrapper{
    height: calc(100% - 48px);
  }
  .pinnacleTable /deep/.el-table__body-wrapper{
    height: calc(100% - 96px);
  }
</style>